module.exports = __webpack_public_path__ + "static/media/money-check.a7d46b0c.svg";